(function () {
  if (window.__amberHour) return;
  window.__amberHour = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('ah-js');

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function init(root) {
    var els = (root || document).querySelectorAll('[data-ah-reveal]:not(.is-in)');
    els.forEach(function (el) {
      if (reduce || !io || window.Shopify && window.Shopify.designMode) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Auto-scrolling slider: <amber-autoslider data-interval="3500" data-autoplay="always|mobile|off"> wrapping [data-track] with [data-slide] children */
(function () {
  if (customElements.get('amber-autoslider')) return;
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMq = window.matchMedia('(max-width: 749px)');

  customElements.define('amber-autoslider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
      this.interval = parseInt(this.dataset.interval || '3500', 10);
      this.mode = this.dataset.autoplay || 'always';
      this.paused = false;
      this.visible = false;
      var self = this;

      this.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.step(parseInt(btn.dataset.dir, 10)); self.restart(); });
      });
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.goTo(parseInt(d.dataset.dot, 10)); self.restart(); });
      });

      var pause = function () { self.paused = true; };
      var resume = function () { self.paused = false; };
      this.addEventListener('mouseenter', pause);
      this.addEventListener('mouseleave', resume);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', resume);
      this.track.addEventListener('touchstart', pause, { passive: true });
      this.track.addEventListener('touchend', function () { setTimeout(resume, 4000); }, { passive: true });

      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { self.updateDots(); ticking = false; });
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) { self.visible = entries[0].isIntersecting; }, { threshold: 0.3 });
        this.io.observe(this);
      } else { this.visible = true; }

      this.restart();
    }
    disconnectedCallback() { clearInterval(this.timer); if (this.io) this.io.disconnect(); }
    canAuto() {
      if (reduceMq.matches || this.mode === 'off') return false;
      if (this.mode === 'mobile' && !mobileMq.matches) return false;
      return this.track.scrollWidth - this.track.clientWidth > 4;
    }
    restart() {
      var self = this;
      clearInterval(this.timer);
      this.timer = setInterval(function () {
        if (self.paused || !self.visible || document.hidden || !self.canAuto()) return;
        self.step(1, true);
      }, this.interval);
    }
    slideWidth() {
      if (this.slides.length < 2) return this.track.clientWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }
    step(dir, loop) {
      var loopN = parseInt(this.dataset.loop || '0', 10);
      if (loopN > 0 && this.slides.length >= loopN * 2) {
        var w = this.slideWidth();
        var span = w * loopN;
        var t = this.track;
        if (dir > 0 && t.scrollLeft >= span - 4) { t.style.scrollSnapType = 'none'; t.scrollLeft = t.scrollLeft - span; }
        else if (dir < 0 && t.scrollLeft <= 4) { t.style.scrollSnapType = 'none'; t.scrollLeft = t.scrollLeft + span; }
        t.scrollTo({ left: Math.round(t.scrollLeft / w) * w + dir * w, behavior: reduceMq.matches ? 'auto' : 'smooth' });
        clearTimeout(this.snapTimer);
        this.snapTimer = setTimeout(function () { t.style.scrollSnapType = ''; }, 700);
        return;
      }
      var max = this.track.scrollWidth - this.track.clientWidth;
      var target = this.track.scrollLeft + dir * this.slideWidth();
      if (dir > 0 && this.track.scrollLeft >= max - 4) target = 0;
      else if (dir < 0 && this.track.scrollLeft <= 4) target = max;
      this.track.scrollTo({ left: target, behavior: reduceMq.matches ? 'auto' : 'smooth' });
    }
    goTo(i) {
      var s = this.slides[i];
      if (!s) return;
      this.track.scrollTo({ left: s.offsetLeft - this.slides[0].offsetLeft, behavior: reduceMq.matches ? 'auto' : 'smooth' });
    }
    updateDots() {
      if (!this.dots.length) return;
      var ln = parseInt(this.dataset.loop || '0', 10);
      if (ln > 0) {
        var idx = Math.round(this.track.scrollLeft / this.slideWidth()) % ln;
        this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        return;
      }
      var max = this.track.scrollWidth - this.track.clientWidth;
      var ratio = max > 0 ? this.track.scrollLeft / max : 0;
      var active = Math.round(ratio * (this.dots.length - 1));
      this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }
  });
})();

/* Product card: quantity stepper and wishlist heart (shares the theme's saved wishlist) */
(function () {
  if (window.__amberCard) return;
  window.__amberCard = true;
  var KEY = 'localWishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-ah-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.ahWish) > -1 ? 'true' : 'false');
    });
    document.querySelectorAll('.js-wishlist-count').forEach(function (c) { c.textContent = list.length; });
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input[name="quantity"]');
      if (input) {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
        input.value = v;
      }
      return;
    }
    var wish = e.target.closest('[data-ah-wish]');
    if (wish) {
      e.preventDefault();
      var list = read();
      var h = wish.dataset.ahWish;
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      localStorage.setItem(KEY, JSON.stringify(list));
      wish.classList.remove('is-pop'); void wish.offsetWidth; wish.classList.add('is-pop');
      sync();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('shopify:section:load', sync);
})();

/* Amber add-to-cart: glass cards and spotlight add without leaving the page, then open the cart drawer */
(function () {
  if (window.__amberAtc) return;
  window.__amberAtc = true;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('.ah-card__form, #AmberSpotlightForm') : null;
    if (!form || !window.theme || !window.theme.miniCart || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); })
      .then(function () {
        window.theme.miniCart.generateCart();
        window.theme.miniCart.updateElements();
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart';
        if (window.theme.alert && window.theme.alert.new) window.theme.alert.new('', msg, 3000, 'warning'); else window.alert(msg);
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  });
})();
